<div class="container main-content mt-5 pt-5 col-lg-10 col-md-10 col-12">
  <div class="custom-card">
    <div class="card-body">
      <div class="row align-items-center d-flex justify-content-between">
        <div class="col-12 col-md-5">
          <h2 class="custom-card-title">Projects</h2>
        </div>

        <div class="col-12 col-md-5 d-flex justify-content-end gap-2 flex-column flex-md-row">
          <div>
            <button class="btn btn-primary d-flex align-items-center"
                    (click)="exportCSV(filteredProjects,'Projects.csv')" id="download">
              <span *ngIf="!downloadedTable" class="material-symbols-outlined me-1"
                    style="font-size: 1.2rem">download</span>
              <span *ngIf="downloadedTable" class="material-symbols-outlined me-1"
                    style="font-size: 1.2rem"> download_done</span>
              Export Projects
            </button>
          </div>
        </div>
      </div>
      <div class="row align-items-center mb-3 d-flex justify-content-between">
        <div class="col-12 col-md-5 mb-3">
          <input type="text" class="form-control" placeholder="Search projects..." [(ngModel)]="searchText"
                 (input)="onSearchTextChange()">
        </div>

        <select *ngIf="teacher?.role === 'Admin'" class="form-select mb-3" (change)="showProject($event)">
          <option disabled>Admin Filter</option>
          <option selected value="All Projects">All Projects</option>
          <option value="Deleted">Deleted</option>
          <option value="Active">Active</option>
        </select>

        <div class="col-12 col-md-5 d-flex justify-content-end gap-2 flex-column flex-md-row">
          <div>
            <!-- Create New Profile Button -->
            <a routerLink="/new-project" class="btn btn-primary d-inline-flex align-items-center"
               style="white-space: nowrap;" *ngIf="teacher?.role !== 'Science Directors'">
              New Project
              <span class="material-symbols-outlined ms-1">add</span>
            </a>
          </div>
          <select class="form-select mb-3" aria-label="Number of cards per page" (change)="selectChange($event)">
            <option selected value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="All">All</option>
          </select>
          <div class="dropdown mb-3">
            <button class="btn btn-primary dropdown-toggle w-100" type="button" data-bs-toggle="dropdown"
                    data-bs-auto-close="outside">
              {{ gradeDropdownText }}
            </button>
            <ul class="dropdown-menu w-100">
              <li *ngFor="let grade of grades">
                <label class="dropdown-item user-select-none">
                  <input class="form-check-input" type="checkbox" [value]="grade"
                         [checked]="findProjectsForm.selectedGrades.includes(grade)"
                         (change)="onGradeChange($event, grade)">
                  {{ grade }}
                </label>
              </li>
            </ul>
          </div>
        </div>
        <div id="row-section">
          <table class="table">
            <thead>
            <tr>
              <th>
                <select class="form-select form-select-sm" (change)="onStatusSortChange($event)">
                  <option value="">Project Status</option>
                  <option *ngFor="let status of projectStatusOrder" [value]="status">{{ status }}</option>
                </select>
              </th>
              <th (click)="sort('year')">
                Year
                <span *ngIf="getSortDir('year') === 'asc'"
                      class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                <span *ngIf="getSortDir('year') === 'desc'"
                      class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                <span *ngIf="getSortDir('year') !== 'desc' && getSortDir('year') !== 'asc'"
                      class="material-symbols-outlined">swap_vert</span>
              </th>
              <th (click)="sort('teacher')">
                Teacher Name
                <span *ngIf="getSortDir('teacher') === 'asc'"
                      class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                <span *ngIf="getSortDir('teacher') === 'desc'"
                      class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                <span *ngIf="getSortDir('teacher') !== 'desc' && getSortDir('teacher') !== 'asc'"
                      class="material-symbols-outlined">swap_vert</span>
              </th>
              <th (click)="sort('date')">
                Created Date
                <span *ngIf="getSortDir('date') === 'asc'"
                      class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                <span *ngIf="getSortDir('date') === 'desc'"
                      class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                <span *ngIf="getSortDir('date') !== 'desc' && getSortDir('date') !== 'asc'"
                      class="material-symbols-outlined">swap_vert</span>
              </th>
              <th (click)="sort('updatedDate')">
                Updated Date
                <span *ngIf="getSortDir('updatedDate') === 'asc'" class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                <span *ngIf="getSortDir('updatedDate') === 'desc'" class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                <span *ngIf="getSortDir('updatedDate') !== 'desc' && getSortDir('updatedDate') !== 'asc'"
                      class="material-symbols-outlined">swap_vert</span>
              </th>
              <th (click)="sort('school')">
                School Name
                <span *ngIf="getSortDir('school') === 'asc'"
                      class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                <span *ngIf="getSortDir('school') === 'desc'"
                      class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                <span *ngIf="getSortDir('school') !== 'desc' && getSortDir('school') !== 'asc'"
                      class="material-symbols-outlined">swap_vert</span>
              </th>
              <th (click)="sort('title')">
                Project Name
                <span *ngIf="getSortDir('title') === 'asc'"
                      class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                <span *ngIf="getSortDir('title') === 'desc'"
                      class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                <span *ngIf="getSortDir('title') !== 'desc' && getSortDir('title') !== 'asc'"
                      class="material-symbols-outlined">swap_vert</span>
              </th>
            </tr>
            </thead>
            <tbody *ngIf="pagedCards.length > 0; else noProjects">
            <ng-container *ngFor="let project of pagedCards; let i = index">
              <!-- Main Row -->
              <tr
                (click)="onProjectCardClicked(project.id)"
              >
                <td (mouseenter)="hoveredRow = i"
                    (mouseleave)="hoveredRow = null"
                    style="cursor:pointer;" [ngStyle]="{color: (project.projectStatus == 'Rework') ? '#FF0000': '#000'}">
                  {{ project.projectStatus }}
                </td>
                <td>{{ project.schoolYear }}</td>
                <td>{{ project.representativeName }}</td>
                <td>{{ project.dateSubmitted | date:'MMM d, yyyy' }}</td>
                <td>{{ project.dateEdited | date:'MMM d, yyyy' }}</td>
                <td>{{ project.school }}</td>
                <td>{{ project.title }}</td>
              </tr>

              <!-- Hover -->
              <tr *ngIf="hoveredRow === i">
                <td colspan="7" class="p-0">
                  <div class="p-3 m-0">
                    <app-project-card
                      [project]="project"
                      (cardClicked)="onProjectCardClicked($event)">
                    </app-project-card>
                  </div>
                </td>
              </tr>
            </ng-container>
            </tbody>
          </table>
          <ul class="pagination" *ngIf="totalPages > 1">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <a class="page-link" (click)="goToPrevious()">Previous</a>
            </li>

            <ng-container *ngFor="let page of pages">
              <li class="page-item" *ngIf="page === 1"
                  [class.active]="page === currentPage">
                <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
              </li>
              <li class="page-item disabled"
                  *ngIf="page === currentPage - 2 && page > 2">
                <span class="page-link">…</span>
              </li>
              <li class="page-item"
                  *ngIf="page >= currentPage - 1 && page <= currentPage + 1 && page !== 1 && page !== totalPages"
                  [class.active]="page === currentPage">
                <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
              </li>
              <li class="page-item disabled"
                  *ngIf="page === currentPage + 2 && page < totalPages - 1">
                <span class="page-link">…</span>
              </li>
              <li class="page-item" *ngIf="page === totalPages"
                  [class.active]="page === currentPage">
                <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
              </li>
            </ng-container>

            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <a class="page-link" (click)="goToNext()">Next</a>
            </li>
          </ul>
          <!--End-->
        </div>

        <ng-template #noProjects>
          <div class="col-12">
            <p class="mb-4">There are no projects.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
